module.exports = __webpack_public_path__ + "static/img/yeswecan0010.64bba17.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0010.png
// module id = 576
// module chunks = 1